
import React from "react";
import { Grid} from "@mui/material";
import "../../styles/new_design.scss";

import HeaderUtah from "../../components/ui/header/HeaderUtah";
import InsideDesign from "../newDesign";


const Crani: React.FC = () => {
 
  return (
    <Grid className="approot new_design">
      <HeaderUtah />
      <InsideDesign />
  </Grid>
  );
};
export default Crani;